import { render, staticRenderFns } from "./AdminDashboardMain.vue?vue&type=template&id=861f35c2&"
import script from "./AdminDashboardMain.vue?vue&type=script&lang=js&"
export * from "./AdminDashboardMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports